/** Errors that the backend will generate */
export enum ApiErrors {
  BAD_REQUEST = 'Bad request',
  UNKNOWN = 'There was a problem when building your transaction. Please try again',
  NOT_ENOUGH_MONEY = "You don't have enough tokens for this.",
  INVALID_IMAGE = 'Image format is not valid',
  INVALID_ORDER = 'Invalid order',
  CANT_CANCEL_IN_PROGRESS = "Order being processed. Can't cancel right now",
  ORDER_NOT_FOUND = 'Order not found',
  ALREADY_CANCELLING = 'Order already in cancelling process',
  ALREADY_CANCELLED = 'Order already cancelled',
  ORDER_CBOR_INVALID = 'The provided order is not valid',
  SERVER_DOWN = 'Our servers are currently down. Please try again later',
  UNAUTHORIZED = 'Unauthorized',
  ORDER_EXPIRED = 'This order expired',
  ORDER_MIGHT_HAVE_BEEN_CANCELLED = "Can't cancel this order",
  PORTFOLIO_NOT_FOUND = "The portfolio you requested doesn't exist",
  PORTFOLIO_CBOR_INVALID = 'The provided transaction is not valid',
  RUN_OUT_OF_FUNDS = "Your request might have clashed with someone else's. Try again",
  OVER_BUDGET = 'You requested too much for today. Try with other tokens or tomorrow.',
}
